import isNil from "lodash/isNil";

import { SMTTestID } from "@/constants/TestID";
import { useAppSelector } from "@/store/hooks";
import {
  selectEntryPhotoUri,
  selectUploadingEntryId,
} from "@/store/reducers/smtPhotoUpload";
import SMTUploadBanner from "@/ui/components/smt/SMTUploadBanner";
import { Box } from "@/ui/layout";
import { ZIndexToken } from "@/ui/theme/tokens";
import { isWeb } from "@/utils/platform.util";

const SMTUploadBannerHeader = () => {
  const uploadingEntryId = useAppSelector(selectUploadingEntryId);
  const photoUri = useAppSelector(selectEntryPhotoUri(uploadingEntryId ?? ""));
  const isUploading = !isNil(uploadingEntryId);

  if (!isUploading) return null;

  // on web, the tab bar sits at the top of the screen, so render the banner in-flow
  // to stack it above the tab bar (pushing it down) rather than overlaying/hiding it.
  const [position, zIndex] = isWeb()
    ? [undefined, undefined]
    : ["absolute" as const, ZIndexToken.Toast];

  return (
    <Box
      position={position}
      testID={SMTTestID.UploadBannerWrapper}
      width="100%"
      zIndex={zIndex}
    >
      <SMTUploadBanner photoUri={photoUri} />
    </Box>
  );
};

export default SMTUploadBannerHeader;
